export default __webpack_public_path__ + "static/media/pilots.1ee837cb.jpg";